import { Button, Modal } from "antd";
import * as React from "react";
import { Blocker } from "react-router-dom";

interface Props {
  blocker: Blocker;
  nextLocationRef: React.RefObject<string>;
}
export const CpFormPrompt: React.FC<Props> = ({ blocker, nextLocationRef }) => {
  if (blocker.state === "blocked") {
    return (
      <Modal
        open={true}
        maskClosable={true}
        closable={true}
        onCancel={() => blocker.reset()}
        title={`Warning!`}
        footer={() => (
          <div className="flex items-center justify-end gap-4">
            <Button onClick={() => window.open(`${nextLocationRef.current}`)} type={`default`}>
              Open New Tab
            </Button>
            <Button onClick={() => blocker.reset()} type={`primary`}>
              Continue Editing
            </Button>
            <Button onClick={() => blocker.proceed()} type={`default`} danger>
              Discard Changes
            </Button>
          </div>
        )}
      >
        There are unsaved changes.
      </Modal>
    );
  }

  return null;
};
